import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { OrderStatus, ShortOrderItemModel } from "../models/OrderModel";
import { OrderService } from "../services/OrderService";

export function useOrderVM() {
    const orderService = new OrderService();

    const [item, setItem] = useState<ShortOrderItemModel | null>(null);
    const [items, setItems] = useState<ShortOrderItemModel[]>([]);

    const [listHash, setListHash] = useState<number>(0);
    const [selectedInvoice, setSelectedInvoice] = useState<string>("");
    const [showInvoice, setShowInvoice] = useState<boolean>(false);

    const [loading, setLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const getList = (getCount: boolean) => {
        setLoading(true);
        setItems([]);
        setListHash(Utils.getRandomKey());

        const request = orderService.getList(OrderStatus.all);
        DataUtils.onRequest(request, onSearchResult);
    }

    const onSearchResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const orders = result.data as ShortOrderItemModel[];
            setItems(orders);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    const get = (id: number) => {
        setLoading(true);
        setItem(null);
        const request = orderService.get(id);
        DataUtils.onRequest(request, onGetResult);
    }

    const onGetResult = (result: IDataResult) => {
        const order = result.data as ShortOrderItemModel | null | undefined;

        if (order != null) {
            setItem(order);
        }

        setLoading(false);
    }

    return {
        item, setItem,
        items,
        listHash,

        selectedInvoice, setSelectedInvoice,
        showInvoice, setShowInvoice,

        loading, setLoading,
        showDetail, setShowDetail,

        getList,
        get
    }
}